import { render, staticRenderFns } from "./DashboardHeaderWidget.vue?vue&type=template&id=37261cbe&scoped=true"
import script from "./DashboardHeaderWidget.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeaderWidget.vue?vue&type=style&index=0&id=37261cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37261cbe",
  null
  
)

export default component.exports